import usePrivateAxios from "@/common/api/usePrivateAxios"
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant"
import { Mapper } from "@/common/services/mapper"
import { MetaResponse } from "@/common/types/metaResponse"
import { keepPreviousData, useQuery } from "@tanstack/react-query"

export type UseProductsProps<T> = {
  filters?: {
    search?: string
    page?: number
    category?: string
    allowed_to_company_id?: string
    equipmentTierId?: string
  }
  enabled?: boolean,
  mapper?: (data: any) => T,
}

export const useProducts = <T,>({
  filters: { search = '', page, category, allowed_to_company_id, equipmentTierId } = {},
  mapper = Mapper.default<T>(),
  enabled
}: UseProductsProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    isPending,
    ...rest
  } = useQuery({
    queryKey: ['products', search, page, category, allowed_to_company_id, equipmentTierId],
    queryFn: () => {
      return privateAxios.get(`/products`, {
        params: {
          search,
          page,
          'q[category_id_eq]': category,
          'q[allowed_to_company_id_eq]': allowed_to_company_id,
          'q[equipment_tier_id_eq]': equipmentTierId
        }
      })
    },
    select: (data: { data: { data: any[], meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
    placeholderData: keepPreviousData,
    enabled: enabled
  })

  return { data, meta, isPending, ...rest }
}
